import $ from 'jquery'
import 'slick-carousel'

$(document).ready(dhsv_vc_text_slider())

function dhsv_vc_text_slider() {
  $('.dhsv_vc_text_slider').each(function() {
    $('.js-text-slider', this).slick({
      prevArrow: $('.js-text-prev', this),
      nextArrow: $('.js-text-next', this),
      infinite: false,
    })
    if ($('.text-slider__puzzle-wrapper', this).length) {
      const $this = this
      $('.js-item', this).each(function(index) {
        $('.js-title', this).addClass(`puzzle-item-${index + 1}`)
        $(this)
          .closest('.text-slider')
          .find(`.js-square-${index + 1}`)
          .append($(`.puzzle-item-${index + 1}`, this))
      })
      $('.js-text-slider', this).on('beforeChange', function(
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        $('.js-square', $this).removeClass('active')
        $('.puzzle1', $this).removeClass('active')
        $(
          `.js-square-${nextSlide + 1}, .square-${nextSlide + 1}`,
          $this
        ).addClass('active')
      })
      $('.js-square', this).click(function() {
        const index =
          parseInt(
            $(this)
              .attr('class')
              .replace(/[^\d]/g, ''),
            10
          ) - 1
        const textSlider = $(this)
          .closest('.text-slider')
          .find('.js-text-slider')
        textSlider.slick('slickGoTo', index)
      })
    }
  })
}
